import { useLivenessMachine } from '../components/machine-provider';

export default useLivenessMachine;
